import type { OccasionNavModelProps } from '@/components/occasion/occasion-page/components/occasion-nav/occasion-nav.model'
import { useOccasionNavModel } from '@/components/occasion/occasion-page/components/occasion-nav/occasion-nav.model'
import { OccasionNavView } from '@/components/occasion/occasion-page/components/occasion-nav/occasion-nav.view'

export function OccasionNavViewModel(props: OccasionNavModelProps) {
  const model = useOccasionNavModel(props)
  return <OccasionNavView {...model} />
}
